import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { OrderedSet, Record } from 'immutable';

export const TagSliceKey = 'tags';

interface ITagSliceState {
	availableTags: OrderedSet<AppTagItemEntity>;
}

const tagDefaults: ITagSliceState = {
	availableTags: OrderedSet(),
};

export class TagSliceState extends Record<ITagSliceState>(tagDefaults) {
	public setTags(tags: OrderedSet<AppTagItemEntity>): TagSliceState {
		return this.set('availableTags', tags);
	}
}
